module.exports = __webpack_public_path__ + "static/media/atom.823f3ff6.png";